import React, { Component } from 'react';
import './Header.css';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { setNavBarState } from '../../../actions/layoutActions';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import { HashLink } from "react-router-hash-link";
import logo from '../../../assets/logo.png';


class Header extends Component {
  static propTypes = {
    setNavBarState: PropTypes.func.isRequired
  };

  state = {
    small: false
  };

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    if (window.scrollY > 0) {
      this.setState({ small: true });
    } else {
      this.setState({ small: false });
    }
  }

  render() {
    return (
      <header className={classnames({
        'header--small': this.state.small
      })}>
        <nav>
          <div className="right">
            <HashLink smooth to="/#rolam" offset="100" className="nav__item">Rólam</HashLink>
            <HashLink smooth to="/#modszertan" offset="100" className="nav__item">Módszertan</HashLink>
            <HashLink smooth to="/#velemenyek" offset="100" className="nav__item">Vélemények</HashLink>
          </div>
          <Link to="/" className="nav__item--logo">
            <img src={logo} alt="Berki Melinda logo"/>
          </Link>
          <div className="left">
            <HashLink smooth to="/#kurzusok" offset="100" className="nav__item">Kurzusok</HashLink>
            <HashLink smooth to="/#blog" offset="100" className="nav__item">Blog</HashLink>
            <Link to="/kapcsolat" className="nav__item">Kapcsolat</Link>
          </div>
          <div className="nav__item nav__item--mobile" onClick={this.props.setNavBarState}>
            <i className="fas fa-bars"></i>
          </div>
        </nav>
        <div className="bar"></div>
      </header>
    );
  }
}


const mapDispatchToProps = {
  setNavBarState
};


export default connect(null, mapDispatchToProps)(Header);


// WEBPACK FOOTER //
// ./src/components/layout/Header/Header.js